module.exports = __webpack_public_path__ + "img/mail_gray-light.92786fd8.svg";